export const TABS_KEYS = {   
    orgInfo: 'orgInfo',
    groupCompanyInfo: 'groupCompanyInfo',
    submitGroupCompany: 'submitGroupCompany',
    groupCompanyProtocol: 'groupCompanyProtocol',
} as const;

export const TABS_TITLES = {
    orgInfo: 'Сведения об организациях',
    groupCompanyInfo: 'Сведения по структуре ГК',
    groupCompanyProtocol: 'Протоколы обработки сведений по структуре ГК',
    submitGroupCompany: 'Запрос на изменение сведений по ГК',
} as const;

export const TAB_HEADERS = {
    submitGroupCompanyHeader:
        'Запросы на изменение сведений о наименовании группы компаний и (или) головной организации группы компаний',
} as const;

export const SUBMIT_GROUP_COMPANY_DRAFT_NAME = 'Черновик' as const;

export const HAS_FOREIGN_PARENT_FIELD_VALUES = {
    'есть': '1',
    'нет': '2'
} as const;

export const CHANGE_GROUP_COMPANY_V5_SERVICE_NAME = 'changeCompanyGroupInfo-v5-EXTERNAL' as const;

export const AIS_SERVICES_LOOKUP_URL = 'ais/valueLists/AIS_SERVICES' as const;
